import React from "react";
import { Package, Truck, Clock } from "lucide-react";
import { LOCATION_LABELS } from "components/admin/tokens";

const fmtNum = (n) => new Intl.NumberFormat("mn-MN").format(parseInt(n, 10) || 0);
const fmtDate = (d) => {
  if (!d) return "";
  const x = new Date(d);
  return isNaN(x.getTime()) ? "" : x.toLocaleDateString("mn-MN");
};

// Ачааны байршлын төлөв: Эрээнд / Монгол руу ачигдсан / Монголд ирсэн
const locationInfo = (loc) => {
  if (loc === "Эрээнд") return { text: LOCATION_LABELS["Эрээнд"], cls: "text-amber-600" };
  if (loc === "Ачигдсан") return { text: LOCATION_LABELS["Ачигдсан"], cls: "text-blue-600" };
  return { text: LOCATION_LABELS["Монголд"], cls: "text-green-700" };
};

const statusBadge = (type) => {
  if (type === "Тийм") return { text: "Хүлээлгэн өгсөн", cls: "bg-green-100 text-green-700" };
  if (type === "Хүргэлт") return { text: "Хүргэлтэд гарсан", cls: "bg-amber-100 text-amber-700" };
  return { text: "Хүлээгдэж буй", cls: "bg-slate-100 text-slate-600" };
};

const TrackResult = ({ data = [], checked }) => {
  if (!data.length) {
    if (checked) {
      return (
        <div className="mt-4 flex items-center gap-2 rounded-lg bg-red-50 text-red-600 px-4 py-3 text-sm font-medium">
          <Package className="w-4 h-4" /> Танд ачаа ирээгүй байна.
        </div>
      );
    }
    return null;
  }

  const total = data.reduce((a, c) => a + (parseInt(c.price, 10) || 0), 0);

  return (
    <div className="mt-4 text-left">
      <div className="flex items-center gap-2 text-green-700 font-semibold text-sm mb-3">
        <Package className="w-4 h-4" /> Танд {data.length} ширхэг ачаа ирсэн байна.
      </div>

      <div className="space-y-3 max-h-[340px] overflow-y-auto pr-1">
        {data.map((c, i) => {
          const badge = statusBadge(c.type);
          const loc = locationInfo(c.location);
          return (
            <div key={i} className="rounded-xl border border-gray-200 p-4 hover:border-primary/40 transition-colors">
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div>
                  <div className="font-bold text-foreground">{c.name}</div>
                  <div className="mt-1 flex items-center gap-3 text-xs text-muted-foreground">
                    <span className={`inline-flex items-center gap-1 font-semibold ${loc.cls}`}>
                      <Truck className="w-3.5 h-3.5" />{loc.text}
                    </span>
                    {c.updatedAt && (
                      <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{fmtDate(c.updatedAt)}</span>
                    )}
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-bold text-foreground">{fmtNum(c.price)} ₮</div>
                  <span className={`inline-block mt-1 text-[11px] font-bold px-2 py-0.5 rounded-full ${badge.cls}`}>{badge.text}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {data.length > 1 && (
        <div className="mt-3 flex justify-between items-center border-t border-gray-200 pt-3">
          <span className="text-sm font-semibold text-muted-foreground">Нийлбэр дүн</span>
          <span className="font-bold text-foreground">{fmtNum(total)} ₮</span>
        </div>
      )}
    </div>
  );
};

export default TrackResult;
